import { getIsIntegrated as getIsAppraisalPortIntegrated } from "requests/appraisalPort/";
import { getIsIntegrated as getIsWestAmcIntegrated } from "requests/westAmc/";
import { getIsIntegrated as getIsDwellingBlocksIntegrated } from "requests/dwellingBlocks/";

export const getIntegrationStatuses = (customerNumber: number, integrations: string[], successCallback: ({}) => void, errorCallback, mounted: any) => {
  const status = {};
  let completed = 0;

  const checkDone = () => {
    if (completed === integrations.length) {
      successCallback(status);
    }
  };

  integrations.forEach((integration) => {
    let checkIntegrationStatus: Function;

    switch (integration) {
      case "appraisalPort":
        checkIntegrationStatus = getIsAppraisalPortIntegrated;
        break;
      case "westAmc":
        checkIntegrationStatus = getIsWestAmcIntegrated;
        break;
      case "dwellingBlocks":
        checkIntegrationStatus = getIsDwellingBlocksIntegrated;
        break;
      default:
        return;
    }

    checkIntegrationStatus(customerNumber, (response: boolean) => {
      status[integration] = response;
      completed += 1;
      checkDone();
    }, mounted);
  });
};
